import { useState } from 'react';
import numberUtils from '../../utils/numberUtils';

const useReviewSecurityDeposit = (
  securityDepositSelectionFromListing: string | null | number,
  securityDepositFromListing: string | number,
) => {
  const [securityDepositSelection, setSecurityDepositSelection] = useState(securityDepositSelectionFromListing);
  const [securityDepositInputValue, setSecurityDepositInputValue] = useState(securityDepositFromListing);

  const setSecurityDepositOptions = (selectionType: string, inputValue: string) => {
    setSecurityDepositSelection(selectionType);

    if (numberUtils.isOnlyIntegers(inputValue) || inputValue === '') {
      setSecurityDepositInputValue(inputValue);
    }
  };

  return { securityDepositSelection, securityDepositInputValue, setSecurityDepositOptions };
};

export default useReviewSecurityDeposit;
